import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "relative flex flex-col h-full px-12 pt-16 pb-6 bg-white rounded-lg dark:bg-gray-700 shadow-200 dark:border dark:border-gray-900" };
const _hoisted_2 = {
    key: 1,
    class: "flex flex-col flex-1 min-h-0 pb-8"
};
const _hoisted_3 = { class: "pb-4 text-2xl font-bold text-primary-900 dark:text-gray-300" };
const _hoisted_4 = { class: "flex flex-col items-center justify-center -mb-1 sm:flex-row sm:justify-end sm:mb-0 sm:-mr-8" };
import transitions from '@/helpers/transitions';
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalDialog',
    props: {
        centered: { type: Boolean },
        dismissAction: null,
        primaryActions: null,
        secondaryActions: null,
        show: { type: Boolean },
        tertiaryActions: null
    },
    emits: ['action'],
    setup(__props, { emit }) {
        const props = __props;
        const handleAction = (action) => {
            emit('action');
            action();
        };
        const { scale, slideY } = transitions;
        const enter = (element, done) => {
            if (props.centered) {
                scale.scaleIn(element, done);
            }
            else {
                slideY.slideYIn(element, done);
            }
        };
        const leave = (element, done) => {
            if (props.centered) {
                scale.scaleOut(element, done);
            }
            else {
                slideY.slideYOut(element, done);
            }
        };
        return (_ctx, _cache) => {
            const _component_paragraph = _resolveComponent("paragraph");
            const _component_text_button = _resolveComponent("text-button");
            const _component_pill_button = _resolveComponent("pill-button");
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createBlock(_component_transition_a11y, {
                css: false,
                enter: enter,
                leave: leave
            }, {
                default: _withCtx(() => [
                    (__props.show)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["absolute z-50 max-h-full p-5", __props.centered ? 'absolute-center' : 'right-0 bottom-0'])
                        }, [
                            _createElementVNode("div", _hoisted_1, [
                                (__props.dismissAction)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "absolute top-0 right-0 mt-4 mr-4",
                                        onClick: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (__props.dismissAction && __props.dismissAction(...args)))
                                    }, [
                                        _createVNode(SvgIcon, {
                                            name: "x",
                                            class: "w-5 h-5"
                                        })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.$slots.body)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _renderSlot(_ctx.$slots, "body")
                                    ]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                        _createVNode(_component_paragraph, { class: "pb-8" }, {
                                            default: _withCtx(() => [
                                                _renderSlot(_ctx.$slots, "before")
                                            ], undefined, true),
                                            _: 3
                                        }),
                                        _createElementVNode("p", _hoisted_3, [
                                            _renderSlot(_ctx.$slots, "heading")
                                        ]),
                                        _createVNode(_component_paragraph, { class: "flex-1 pb-8" }, {
                                            default: _withCtx(() => [
                                                _renderSlot(_ctx.$slots, "after")
                                            ], undefined, true),
                                            _: 3
                                        })
                                    ], 64)),
                                _createElementVNode("div", _hoisted_4, [
                                    _renderSlot(_ctx.$slots, "default"),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.secondaryActions, (action, text) => {
                                        return (_openBlock(), _createBlock(_component_text_button, {
                                            key: text,
                                            class: "mb-1 sm:mb-0 sm:mr-8",
                                            onClick: ($event) => (handleAction(action))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(text), 1)
                                            ], undefined, true),
                                            _: 2
                                        }, 1032, ["onClick"]));
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tertiaryActions, (action, text) => {
                                        return (_openBlock(), _createBlock(_component_text_button, {
                                            key: text,
                                            class: "px-5 mb-1 border rounded-full sm:mb-0 sm:mr-8",
                                            onClick: ($event) => (handleAction(action))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(text), 1)
                                            ], undefined, true),
                                            _: 2
                                        }, 1032, ["onClick"]));
                                    }), 128)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.primaryActions, (action, text) => {
                                        return (_openBlock(), _createBlock(_component_pill_button, {
                                            key: text,
                                            class: "mb-1 sm:mb-0 sm:mr-8",
                                            onClick: ($event) => (handleAction(action))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(text), 1)
                                            ], undefined, true),
                                            _: 2
                                        }, 1032, ["onClick"]));
                                    }), 128))
                                ])
                            ])
                        ], 2))
                        : _createCommentVNode("", true)
                ], undefined, true),
                _: 3
            }));
        };
    }
});
